import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  open: `${NAMESPACE}_ROUTE_STOCK_SUMMARY_MODAL_OPENED`,
  close: `${NAMESPACE}_ROUTE_STOCK_SUMMARY_MODAL_CLOSED`
};

export const actionCreators = {
  open: () => ({ type: actions.open }),
  close: () => ({ type: actions.close })
};

export default {
  actions,
  actionCreators
};
